import MagnumSays from '@/components/MagnumSays'
import { ActCatalog, SectionPace, formatDuration } from '@/lib/actModes'

/**
 * First thing every round asks: which section. Only the three he's sitting for
 * -- Science and Writing aren't on his test, so they aren't on his screen.
 */
export default function ActSectionPicker({
  catalog,
  pace,
  onPick,
}: {
  catalog: ActCatalog | null
  pace: SectionPace[]
  onPick: (key: string) => void
}) {
  return (
    <div className="space-y-5">
      <MagnumSays>What are we working on?</MagnumSays>

      <div className="space-y-3">
        {(catalog?.sections || []).map(s => {
          const row = pace.find(p => p.section === s.key)
          return (
            <button
              key={s.key}
              type="button"
              onClick={() => onPick(s.key)}
              className="w-full flex items-center gap-4 px-5 py-5 rounded-2xl border-2 border-border hover:border-primary hover:bg-accent transition text-left min-h-[44px]"
            >
              <span className="text-3xl shrink-0">{s.emoji}</span>
              <span className="flex-1">
                <span className="block text-xl font-bold">{s.label}</span>
                <span className="block text-xs text-muted-foreground">
                  {s.questions} questions in {s.minutes} min · {formatDuration(s.secondsPerQuestion)} each
                </span>
              </span>
              {row && row.avgSecondsPerQuestion != null && (
                <span className="text-right shrink-0">
                  <span className="block text-lg font-bold tabular-nums">
                    {formatDuration(row.avgSecondsPerQuestion)}
                  </span>
                  <span className="block text-[11px] text-muted-foreground">your pace</span>
                </span>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
